import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { OutcomeFilter as OutcomeFilterEnum } from '@/services/ws-funnel/src/main/resources/rest-api';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Filter } from '@/js/libs/ui/src/V2';

import { useTranslateOptionLabel } from 'src/hooks/useTranslateOptionLabel';
import type { Option } from 'src/types';
import { useTaskTablesContext } from '../../context';

const options: Option<OutcomeFilterEnum>[] = [
  { label: OutcomeFilterEnum.OFFER_ACCEPTED, value: OutcomeFilterEnum.OFFER_ACCEPTED },
  { label: OutcomeFilterEnum.OFFER_NOT_ACCEPTED, value: OutcomeFilterEnum.OFFER_NOT_ACCEPTED },
];

export const OutcomeFilter: FC = () => {
  const [t] = useTranslation(['backend', 'common', 'serviceDashboard']);
  const formatOptionLabel = useTranslateOptionLabel(t, 'serviceDashboard');
  const filters = useTaskTablesContext('filters$');
  const { updateFilter } = useTaskTablesContext();

  const handleChange = useCallbackRef((option: Option<OutcomeFilterEnum> | null) => {
    updateFilter('outcome', option);
  });

  return (
    <Filter<OutcomeFilterEnum>
      label={t('common:OUTCOME')}
      options={options}
      selected={filters.outcome}
      onChange={handleChange}
      formatOptionLabel={formatOptionLabel}
      isClearable
      dataTestId='outcome-filter'
    />
  );
};
